import React, { useState, ReactNode } from 'react';

interface AlertData {
  title: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info' | '';
}

interface AppContextType {
  alertData: AlertData;
  showAlert: (message: string, type: AlertData['type'], title?: string) => void;
}

export const AppContext = React.createContext<AppContextType>({
  alertData: { title: '', message: '', type: '' },
  showAlert: () => {},
});

interface AppStateProps {
  children: ReactNode;
}

export default function AppState(props: AppStateProps): JSX.Element {
  const [alertData, setAlertData] = useState<AlertData>({
    title: "",
    message: "",
    type: ""
  });

  const showAlert = (message: string, type: AlertData['type'], title: string = ""): void => {
    try {
      setAlertData({ title, message, type });
      setTimeout(() => {
        setAlertData({
          title: "",
          message: "",
          type: ""
        });
      }, 4000);
    } catch (error) {
      console.error('Error showing alert:', error);
    }
  };

  return (
    <AppContext.Provider value={{ showAlert, alertData }}>
      {props.children}
    </AppContext.Provider>
  );
}

